import {
  IMPERSONATOR_TOKEN_KEY,
  CROSS_TENANT_IMPERSONATION_KEY,
} from "../store/actions/adminActions";
import { getProfile } from "../store/actions/profileActions";

function stripQueryParams(...keys) {
  const params = new URLSearchParams(window.location.search);
  keys.forEach((key) => params.delete(key));
  const qs = params.toString();
  return window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
}

/** Whether the current URL carries a cross-origin impersonation handoff. */
export function hasImpersonationHandoffParams() {
  const params = new URLSearchParams(window.location.search);
  return params.has("impersonation_token") || params.has("admin_return_token");
}

/** Tenant subdomain: consume impersonation_token (+ optional return_token). */
export function consumeImpersonationHandoff(dispatch) {
  const params = new URLSearchParams(window.location.search);
  const impToken = params.get("impersonation_token");
  if (!impToken) return false;

  const returnToken = params.get("return_token");
  if (returnToken) {
    sessionStorage.setItem(IMPERSONATOR_TOKEN_KEY, returnToken);
    sessionStorage.setItem(CROSS_TENANT_IMPERSONATION_KEY, "1");
  }

  dispatch({ type: "SWITCH_USER", token: impToken });
  dispatch(getProfile());

  window.history.replaceState({}, "", stripQueryParams("impersonation_token", "return_token"));
  return true;
}

/** Master origin: restore super admin session after cross-tenant return. */
export function consumeAdminReturnHandoff(dispatch) {
  const params = new URLSearchParams(window.location.search);
  const adminToken = params.get("admin_return_token");
  if (!adminToken) return false;

  sessionStorage.removeItem(IMPERSONATOR_TOKEN_KEY);
  sessionStorage.removeItem(CROSS_TENANT_IMPERSONATION_KEY);

  dispatch({ type: "SWITCH_USER", token: adminToken });
  dispatch(getProfile());

  window.history.replaceState({}, "", stripQueryParams("admin_return_token"));
  return true;
}

export function bootstrapImpersonationHandoffs(dispatch) {
  if (consumeAdminReturnHandoff(dispatch)) return;
  consumeImpersonationHandoff(dispatch);
}
